






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
	components: {}
})
export default class SlideUpAndFadeIn extends Vue {
	@Prop({type: Boolean})
	immediate!: boolean;

	mounted() {
		if(this.immediate) {
			this.addSlideUpAndFadeClass((this.$refs.slideUpDiv as HTMLElement));
		}
	}

	addSlideUpAndFadeClass(el: HTMLElement) {
		el.classList.add('slide-up-fade-in');
		setTimeout(() => {
			el.style.opacity = '1';
		}, 490);
	}
}
